import { cva, type VariantProps } from "class-variance-authority";
import React from "react";
import { cn } from "../lib/utils";

const pageVariants = cva("px-4", {
  variants: {
    bg: {
      white: "bg-white",
      transparent: "bg-transparent",
      "beige-lighter": "bg-brand-beige-lighter",
      primary: "bg-brand-primary-dark",
      gradient:
        "relative before:absolute before:inset-0 before:h-[250px] before:bg-gradient-to-b before:from-[#ECF4BF] before:to-brand-beige-lighter before:z-0 bg-brand-beige-lighter", // #ECF4BF
    },
  },
  defaultVariants: {
    bg: "transparent",
  },
});

export interface PageProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof pageVariants> {}

export const Page = React.forwardRef<HTMLDivElement, PageProps>(
  ({ children, className, bg, ...props }, ref) => (
    <div ref={ref} className={cn(pageVariants({ bg }), className)} {...props}>
      {children}
    </div>
  ),
);

Page.displayName = "Page";
